/*
  Who the shop is, in one place.

  These details appear on invoices and in the payment message sent to
  customers over WhatsApp — a bill carrying the wrong address or the
  wrong UPI ID is worse than no bill at all, so they live here rather
  than being repeated in each component.

  ▸ FILL THESE IN BEFORE RAISING A REAL INVOICE ◂
    Anything marked PLACEHOLDER below is not real. The invoice shows a
    visible warning while a placeholder is still in place, so a
    half-configured bill cannot quietly reach a customer.
*/

export const STORE = {
  name: 'Celestial Stones',
  tagline: 'Lab-certified gemstones, aligned with planetary energies',

  // One line per entry; they print stacked on the invoice.
  addressLines: ['Rohini Sector-13', 'Delhi - 110085'],

  phone: '+91 87965 92272',
  email: 'celestialstones33@gmail.com',

  /* Where customers send money. Printed on the invoice and quoted in
     the payment request, so it is public by design — not a secret. */
  upiId: 'parabjain.pj@okaxis',

  /* Leave null while the business is not GST-registered: the document
     is then a plain invoice with no tax lines, which is what was
     approved. Setting a GSTIN does NOT by itself produce a compliant
     tax invoice — that needs HSN codes per item and a CGST/SGST split
     adding to the template first. */
  gstin: null,
};

/*
  The supplier who holds the stock and posts it to the customer.

  Dispatch instructions go to this number from the admin Vendor page,
  so a wrong number here means a parcel that never gets packed.
*/
export const VENDOR = {
  name: 'Vendor',

  /* PLACEHOLDER — the vendor's WhatsApp number. Until this is real the
     Vendor page refuses to send anything. */
  phone: '7071810505',
};

/* Values a real invoice must not go out with. */
const PLACEHOLDERS = ['yourupi@bank'];

/** Which details are still unset, so the invoice can say so plainly. */
export const missingStoreDetails = () => {
  const missing = [];

  if (PLACEHOLDERS.includes(STORE.upiId)) missing.push('UPI ID');
  if (
    STORE.addressLines.length === 1 &&
    /^delhi,\s*india$/i.test(STORE.addressLines[0])
  ) {
    missing.push('full postal address');
  }

  return missing;
};
